import { create } from 'zustand';

export type NotificationType = 'success' | 'error' | 'warning' | 'info';

export interface Notification {
  id: string;
  type: NotificationType;
  message: string;
  duration?: number;
}

interface NotificationsState {
  notifications: Notification[];

  // Actions
  show: (type: NotificationType, message: string, duration?: number) => string;
  success: (message: string, duration?: number) => string;
  error: (message: string, duration?: number) => string;
  warning: (message: string, duration?: number) => string;
  info: (message: string, duration?: number) => string;
  dismiss: (id: string) => void;
  clear: () => void;
}

const DEFAULT_DURATION = 5000;

export const useNotificationsStore = create<NotificationsState>((set, get) => ({
  notifications: [],

  show: (type, message, duration = DEFAULT_DURATION) => {
    const id = crypto.randomUUID();

    set((state) => ({
      notifications: [...state.notifications, { id, type, message, duration }],
    }));

    if (duration > 0) {
      setTimeout(() => {
        get().dismiss(id);
      }, duration);
    }

    return id;
  },

  success: (message, duration) => get().show('success', message, duration),
  error: (message, duration) => get().show('error', message, duration),
  warning: (message, duration) => get().show('warning', message, duration),
  info: (message, duration) => get().show('info', message, duration),

  dismiss: (id) => {
    set((state) => ({
      notifications: state.notifications.filter((n) => n.id !== id),
    }));
  },

  clear: () => {
    set({ notifications: [] });
  },
}));
